import PropTypes from 'prop-types';
import React from 'react';
import {Field} from 'redux-form';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {
    PROPERTY_LICENCE_TYPE_OTHER,
    PROPERTY_LICENCE_TYPE_SPORTRADAR,
} from '@constants/variables';
import Form from '@appComponents/ReduxFormControls';
import {getTodayDate, getEndOfTodayDate} from '@utils/date';
import {defineNextState} from '@utils/filters';
import {DateRangeFilter} from '@utils/commonFilters/DateRangeFilter';
import {EventStatusFilter} from '@utils/commonFilters/EventStatusFilter';
import {ProductsFilter} from '@utils/commonFilters/ProductsFilter';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {ContentCategoriesLevel3Filter} from '@utils/commonFilters/contentCategories/ContentCategoriesLevel3Filter';
import {TournamentsFilter} from '@utils/commonFilters/TournamentsFilter';

import validate from './validatePropertyLicenceEventsFilters';

export class PropertyLicenceEventsFiltersComponent extends React.Component {
    static propTypes = {
        contentCategoriesLevel3: PropTypes.array,
        data: PropTypes.object.isRequired,
        eventStatuses: PropTypes.array,
        filters: PropTypes.object.isRequired,
        form: PropTypes.object.isRequired,
        loading: PropTypes.bool.isRequired,
        reportTypes: PropTypes.array,
        products: PropTypes.array,
        propertyLicenceTypeId: PropTypes.number,
        tournaments: PropTypes.array,
        restoreFilterValues: PropTypes.func.isRequired,
        restoreFilterDateValues: PropTypes.func.isRequired,
        issueOrigins: PropTypes.array,
        issueTypes: PropTypes.array,
    };

    static defaultProps = {
        contentCategoriesLevel3: [],
        eventStatuses: [],
        reportTypes: [],
        products: [],
        tournaments: [],
        issueOrigins: [],
        issueTypes: [],
    };

    constructor() {
        super();

        this.state = {
            fromMaxDate: null,
            fromMaxDateDefault: null,
            fromMaxTime: null,
            toMinDate: null,
            toMinDateDefault: null,
            toMinTime: null,
        };
    }

    onChange = (date, name) => {
        let nextState = {};

        defineNextState(nextState, this.state, date, name);

        this.setState(() => (nextState));
    };

    render() {
        const {
                contentCategoriesLevel3,
                eventStatuses,
                reportTypes,
                products,
                propertyLicenceTypeId,
                tournaments,
                incidentSources,
                incidentTypes,
            } = this.props.data,
            loading = this.props.loading;

        return (
            <div className='propertyLicenceEvents__filters filter__controls__container'>
                <SearchFilter
                    loading={loading}
                    filters={this.props.filters.PropertyLicenceEvents}
                    restoreFilterValues={this.props.restoreFilterValues}
                />
                <DateRangeFilter
                    loading={loading}
                    filters={this.props.filters.PropertyLicenceEvents}
                    restoreFilterDateValues={this.props.restoreFilterDateValues}
                    onChange={this.onChange}
                    dateConfig={{
                        fromMaxDate: this.state.fromMaxDate,
                        fromMaxDateDefault: this.state.fromMaxDateDefault,
                        fromMaxTime: this.state.fromMaxTime,
                        toMinDate: this.state.toMinDate,
                        toMinDateDefault: this.state.toMinDateDefault,
                        toMinTime: this.state.toMinTime,
                    }}
                />
                <TournamentsFilter
                    tournaments={tournaments}
                    loading={loading}
                    filters={this.props.filters.PropertyLicenceEvents}
                    restoreFilterValues={this.props.restoreFilterValues}
                    hidden={propertyLicenceTypeId !== PROPERTY_LICENCE_TYPE_SPORTRADAR}
                />
                <ContentCategoriesLevel3Filter
                    loading={loading}
                    hidden={propertyLicenceTypeId !== PROPERTY_LICENCE_TYPE_OTHER}
                    options={contentCategoriesLevel3}
                    filters={this.props.filters.PropertyLicenceEvents}
                    restoreFilterValues={this.props.restoreFilterValues}
                />
                <EventStatusFilter
                    eventStatuses={eventStatuses}
                    loading={loading}
                    filters={this.props.filters.PropertyLicenceEvents}
                    restoreFilterValues={this.props.restoreFilterValues}
                />
                <ProductsFilter
                    loading={loading}
                    products={products}
                    filters={this.props.filters.PropertyLicenceEvents}
                    restoreFilterValues={this.props.restoreFilterValues}
                />
                <Field
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    multiple
                    name='reportTypes'
                    options={reportTypes}
                    placeholder='Report type'
                    search
                    setValue={this.props.restoreFilterValues(this.props.filters.PropertyLicenceEvents, 'reportTypes')}
                />
                <Field
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    multiple
                    name='incidentSources'
                    options={incidentSources}
                    placeholder='Incident source'
                    search
                    setValue={this.props.restoreFilterValues(this.props.filters.PropertyLicenceEvents, 'incidentSources')}
                />
                <Field
                    component={Form.ReduxSelect}
                    disabled={loading}
                    loading={loading}
                    multiple
                    name='incidentTypes'
                    options={incidentTypes}
                    placeholder='Incident type'
                    search
                    setValue={this.props.restoreFilterValues(this.props.filters.PropertyLicenceEvents, 'incidentTypes')}
                />
            </div>
        );
    }
}

const PropertyLicenceEventsFilters = FiltersWrapper(PropertyLicenceEventsFiltersComponent, {
    name: 'PropertyLicenceEvents',
    validate,
    initialValues: {
        from: getTodayDate(),
        to: getEndOfTodayDate(),
    },
});

export default PropertyLicenceEventsFilters;
